
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Garegaontopunecab() {



    const cardData =
    {
        keyword: 'Goregaon to Pune Cab',
        heading: 'Skyline Cabs: Goregaon to Pune Cab',
        headingDescription: 'Skyline Cabs provides dependable and comfortable Goregaon to Pune Cab services for a smooth intercity journey. Whether you are heading to Pune for business, leisure, or airport transfers, our clean, well-maintained vehicles and experienced drivers ensure a safe and timely ride. With flexible booking options, transparent fares, and 24/7 customer support, Skyline Cabs makes travel from Goregaon to Pune easy and stress-free. Book your cab today and experience the comfort and reliability of Skyline Cabs.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Goregaon to Pune Pimpri Chinchwad Cab",
      "description": "Skyline Cabs offers reliable and affordable taxi services from Goregaon to Pimpri Chinchwad. Whether it's a one-way or round-trip journey, we provide a variety of vehicles including Innova Crysta, Ertiga, and sedans for your comfort."
    },
    {
      "name": "Goregaon to Pune One Way Cab",
      "description": "Book a one-way cab from Goregaon to Pune with Skyline Cabs. We ensure a smooth, hassle-free journey with transparent pricing and a choice of vehicles like Innova Crysta, Ertiga, and sedans."
    },
    {
      "name": "Goregaon to Pune Taxi Service",
      "description": "Travel comfortably from Goregaon to Pune with Skyline Cabs. Our experienced drivers and well-maintained vehicles ensure a safe and enjoyable journey. Choose from various options, including luxury vehicles and SUVs."
    },
    {
      "name": "Taxi Service in Goregaon Mumbai",
      "description": "Skyline Cabs provides dependable taxi services in Goregaon, Mumbai, for both local and outstation trips. Our fleet includes a range of vehicles like Innova Crysta, Ertiga, and sedans for every requirement."
    },
    {
      "name": "Cabs Service Goregaon Mumbai",
      "description": "Skyline Cabs offers premium cab services in Goregaon, Mumbai. Our services include both local and outstation trips, with a wide selection of vehicles available to suit your needs."
    },
    {
      "name": "Malad to Pune Cab Services",
      "description": "Travel from Malad to Pune with Skyline Cabs for a smooth and comfortable ride. We provide reliable taxi services with a variety of vehicle options, including Innova Crysta and Ertiga."
    },
    {
      "name": "Oshiwara Andheri to Pune Taxi Booking",
      "description": "Book a reliable taxi from Oshiwara, Andheri to Pune with Skyline Cabs. Whether you need a one-way trip or a round trip, we offer affordable prices and a range of vehicles to choose from."
    },
    {
      "name": "Goregaon to Hinjewadi Cabs",
      "description": "Skyline Cabs offers direct taxi services from Goregaon to Hinjewadi, Pune. We ensure timely service and affordable fares, with a choice of vehicles like Innova Crysta, Ertiga, and sedan cars."
    },
    {
      "name": "Goregaon to Pune Station Cabs",
      "description": "Book a comfortable and reliable taxi service from Goregaon to Pune Station with Skyline Cabs. We offer fixed pricing and top-rated vehicles, ensuring a pleasant journey."
    },
    {
      "name": "Goregaon to Pune Station Taxi Fare",
      "description": "Skyline Cabs offers competitive pricing for taxis from Goregaon to Pune Station. Our transparent fares include tolls and other charges, ensuring there are no hidden costs for your journey."
    },
    {
      "name": "Taxi Services from Goregaon to Pune Station",
      "description": "Get a dependable taxi from Goregaon to Pune Station with Skyline Cabs. Our professional drivers and comfortable vehicles, including Innova Crysta and Ertiga, ensure a smooth and timely trip."
    },
    {
      "name": "Innova Crysta on Rent Goregaon Mumbai",
      "description": "Skyline Cabs offers Innova Crysta on rent in Goregaon, Mumbai. Whether for a local or outstation trip, enjoy a luxurious ride with ample space and comfort."
    },
    {
      "name": "Cabs Service in Goregaon",
      "description": "Skyline Cabs provides a wide range of cab services in Goregaon, Mumbai, for both local and outstation travel. Book a taxi for your next trip and enjoy seamless service with experienced drivers."
    },
    {
      "name": "Innova Crysta on Rent in Goregaon Mumbai",
      "description": "Looking for a premium ride? Rent an Innova Crysta in Goregaon, Mumbai with Skyline Cabs. Perfect for both local and outstation trips, experience luxury and comfort on the go."
    },
    {
      "name": "Goregaon to Pimpri Chinchwad Cab",
      "description": "Book a reliable cab from Goregaon to Pimpri Chinchwad with Skyline Cabs. Our fleet includes a variety of vehicles to choose from, ensuring a comfortable journey with experienced drivers."
    },
    {
      "name": "Goregaon to Pimpri Chinchwad Cab Fare",
      "description": "Skyline Cabs offers competitive cab fares for the route from Goregaon to Pimpri Chinchwad. Our transparent pricing ensures that you know exactly what you're paying for, with no hidden fees."
    },
    {
      "name": "Goregaon to Swargate Cab",
      "description": "Book a cab from Goregaon to Swargate with Skyline Cabs for a smooth ride. Our fleet includes various vehicle options, such as Innova Crysta, Ertiga, and sedans, ensuring a comfortable and affordable journey."
    },
    {
      "name": "Cab Services in Goregaon Mumbai",
      "description": "Skyline Cabs offers top-notch cab services in Goregaon, Mumbai. Whether you need a local taxi, outstation ride, or airport transfer, we’ve got you covered with a range of vehicles for every need."
    },
    {
      "name": "Taxi Service in Gurgaon for Outstation",
      "description": "Skyline Cabs provides reliable taxi services for outstation travel from Gurgaon to nearby cities and destinations. Enjoy hassle-free journeys with well-maintained vehicles and professional drivers."
    }
  ],
  "tableData": [
    ["Goregaon to Pune Pimpri Chinchwad Cab", "Goregaon to Pune One Way Cab"],
    ["Goregaon to Pune Taxi Service", "Taxi Service in Goregaon Mumbai"],
    ["Cabs Service Goregaon Mumbai", "Malad to Pune Cab Services"],
    ["Oshiwara Andheri to Pune Taxi Booking", "Goregaon to Hinjewadi Cabs"],
    ["Goregaon to Pune Station Cabs", "Goregaon to Pune Station Taxi Fare"],
    ["Taxi Services from Goregaon to Pune Station", "Innova Crysta on Rent Goregaon Mumbai"],
    ["Cabs Service in Goregaon", "Innova Crysta on Rent in Goregaon Mumbai"],
    ["Goregaon to Pimpri Chinchwad Cab", "Goregaon to Pimpri Chinchwad Cab Fare"],
    ["Goregaon to Swargate Cab", "Cab Services in Goregaon Mumbai"],
    ["Taxi Service in Gurgaon for Outstation", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Dependable Goregaon to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable cab services from Goregaon to Pune, ensuring that you reach your destination comfortably and on time. Whether it’s a business trip, a weekend getaway, or a family visit, our service is designed to meet all your travel needs."
    },
    {
        "WhyChooseheading": "Comfortable, Well-Equipped Vehicles",
        "WhyChoosedescription": "Our fleet of well-maintained vehicles provides a comfortable and smooth journey from Goregaon to Pune. Choose from air-conditioned sedans, SUVs, or luxury cars, each equipped with ample legroom and high-quality interiors for your comfort throughout the ride."
    },
    {
        "WhyChooseheading": "Skilled and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are not only skilled but also familiar with the best routes for a timely and safe trip from Goregaon to Pune. They prioritize your safety and comfort, ensuring that you have a pleasant ride with minimal stress."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive pricing with no hidden charges. You’ll always know your fare upfront, ensuring complete transparency and no surprises. Our pricing is designed to provide great value while offering the highest standard of service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether you need an early morning ride or a late-night return, Skyline Cabs operates 24/7 to accommodate your schedule. You can book your Goregaon to Pune cab anytime, ensuring maximum flexibility for your travel plans."
    },
    {
        "WhyChooseheading": "Easy Online Booking Process",
        "WhyChoosedescription": "Booking a cab from Goregaon to Pune is quick and simple with our online booking system. Use our website or mobile app to book your ride in just a few clicks, and enjoy instant booking confirmation with live tracking for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs for Your Journey",
        "WhyChoosedescription": "Your safety and hygiene are our top priorities. All our cabs are sanitized regularly, and our drivers follow strict safety protocols to ensure a clean and secure environment. Travel from Goregaon to Pune with peace of mind knowing you're in safe hands."
    },
    {
        "WhyChooseheading": "Variety of Vehicles for All Travel Needs",
        "WhyChoosedescription": "No matter the size of your group or your specific preferences, we have a vehicle that suits your needs. Whether you're traveling solo, with a group, or with family, Skyline Cabs provides a range of options including sedans, SUVs, and luxury cars for your comfort."
    }
]
























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Goregaon to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Goregaon to Pune is easy! You can either book through our website, mobile app, or call our customer support team for assistance. Just select your pickup location, drop-off destination, choose your vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Goregaon to Pune journey?',
            answer:
                'We offer a range of vehicles to suit your needs including Sedans, SUVs, Ertiga, Innova Crysta, and luxury options. Choose the vehicle type based on your preferences for comfort and space.',
        },
        {
            id: 3,
            question: 'What is the estimated travel time from Goregaon to Pune?',
            answer:
                'The travel time from Goregaon to Pune typically takes 3.5 to 5 hours, depending on traffic conditions. Our experienced drivers will ensure you take the best route for a smooth and timely ride.',
        },
        {
            id: 4,
            question: 'Are the fares for the Goregaon to Pune cab journey fixed?',
            answer:
                'Yes, our fares are fixed and transparent, which include tolls, taxes, and driver charges. The fare is calculated in advance, so you know exactly what to expect before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Goregaon to Pune?',
            answer:
                'Yes, you can book a round-trip service for your journey. Just provide your return details during the booking process, and we’ll make sure your return journey is just as smooth and comfortable.',
        },
        {
            id: 6,
            question: 'Can I modify my Goregaon to Pune cab booking?',
            answer:
                'Yes, you can easily modify or cancel your booking through our website or app. Our customer support team is also available to assist you with any changes to your booking.',
        },
        {
            id: 7,
            question: 'Is the vehicle provided for Goregaon to Pune well-maintained?',
            answer:
                'Yes, we ensure all our vehicles are well-maintained, clean, and equipped with all the necessary amenities for a comfortable ride. Our cars are regularly serviced to meet high safety and comfort standards.',
        },
        {
            id: 8,
            question: 'What payment options are available for booking a cab from Goregaon to Pune?',
            answer:
                'We accept secure online payments through credit/debit cards, UPI, net banking, and cash. Choose the option that works best for you during the booking process.',
        },
        {
            id: 9,
            question: 'Are Skyline Cabs available for corporate travel from Goregaon to Pune?',
            answer:
                'Yes, Skyline Cabs offers corporate travel services. Whether you need a ride for business meetings or corporate events, we can tailor the service to meet your requirements.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Goregaon to Pune trip?',
            answer:
                'Skyline Cabs provides reliable, comfortable, and affordable travel options. With experienced drivers, clean vehicles, and fixed pricing, we ensure a hassle-free journey from Goregaon to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rajesh Patel",
            rating: 5,
            review: "I regularly travel from Goregaon to Pune for work, and Skyline Cabs has been my go-to choice. Their service is prompt, and the drivers are professional. I always feel safe and comfortable during my ride. Highly recommend!"
        },
        {
            name: "Miss. Neha Sharma",
            rating: 4,
            review: "Booked a cab for my weekend trip to Pune from Goregaon. The booking process was easy, and the cab arrived on time. The driver was courteous, and the ride was smooth. I’ll definitely use Skyline Cabs again for my future trips!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goregaon to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/goregaon-to-pune-cab.jpg",
  "description": "Book Goregaon to Pune cabs with Skyline Cabs for a comfortable and affordable ride. Enjoy 24/7 AC cab service with verified drivers, available for both one-way and round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7539"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/goregaon-to-pune-cabs"
  }
};



      
     


    return (
        <div>
<Helmet>
  <title>Goregaon to Pune Cabs | 24/7 Online AC Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Goregaon to Pune cabs with Skyline Cabs for a comfortable and affordable ride. Enjoy 24/7 AC cab service with verified drivers, available for both one-way and round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Goregaon to Pune Cabs, Cab from Goregaon to Pune, One-Way Taxi Goregaon to Pune, Round Trip Cab Goregaon to Pune, AC Cab Goregaon to Pune, SUV Taxi Goregaon to Pune, Online Cab Booking Goregaon to Pune, Affordable Taxi Goregaon to Pune, Skyline Cabs Goregaon to Pune, 24/7 Goregaon to Pune Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/43.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Garegaontopunecab;